import * as React from 'react';
import { isFunction } from 'underscore';
import { ProBadge } from 'components/icons';
import useProIndicator, { UseProIndicatorConfig } from './useProIndicator';

export interface ProIndicatorRenderProps {
  badge: JSX.Element;
  isFree: boolean;
}

export interface ProIndicatorProps extends UseProIndicatorConfig {
  className?: string;
  children?: (props: ProIndicatorRenderProps) => JSX.Element;
}

const ProIndicator: React.FC<ProIndicatorProps> = props => {
  const { blacklist, children, className, feature } = props;
  const { isFree, Badge } = useProIndicator({ blacklist, feature });
  const badge = <Badge className={className} />;

  if (isFunction(children)) {
    return children({ badge, isFree });
  }

  return badge;
};

export default ProIndicator;
export { ProBadge };
